import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";

interface CartHeaderProps {
  itemCount: number;
  onClearAll: () => void;
}

export function CartHeader({ itemCount, onClearAll }: CartHeaderProps) {
  return (
    <SheetHeader className="px-5 py-3">
      <SheetTitle className="flex w-full items-center justify-between">
        <h1 className="text-lg leading-none font-extrabold -tracking-wide text-neutral-800">
          Cart
        </h1>
        {itemCount > 0 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearAll}
            className="pr-4 text-xs text-neutral-600 hover:text-red-500"
          >
            Clear All
          </Button>
        )}
      </SheetTitle>
    </SheetHeader>
  );
}
